import { refreshToken } from '@/services/auth';
import Big from 'big.js';
import moment from 'dayjs';

/**
 * 存储token
 * @param token token信息
 */
export function clearToken() {
  localStorage.removeItem('token');
}

/**
 * 存储token
 * @param token token信息
 */
export function setToken({ token }: { token: string }) {
  localStorage.setItem('token', token);
}

/**
 * 获取token信息
 */
export function getToken() {
  return localStorage.getItem('token') || '';
}

/**
 * 获取token信息
 */
export function getTokenInfo() {
  const tokenString = localStorage.getItem('token');
  if (!tokenString) {
    return {};
  }
  const [, payload] = tokenString.split('.');
  return {
    ...JSON.parse(Buffer.from(payload, 'base64').toString()),
  };
}

/**
 * 从token中获取用户id
 */
export function getUserId() {
  return getTokenInfo().id;
}

/**
 * 判断登陆态
 */
export async function isLogin(): Promise<boolean> {
  const res = getTokenInfo();
  if (
    res &&
    moment()
      .add(1, 'minute')
      .isBefore(
        Big(res.exp || 0)
          .mul(1000)
          .toNumber(),
      )
  ) {
    if (
      moment()
        .add(5, 'minute')
        .isAfter(
          Big(res.exp || 0)
            .mul(1000)
            .toNumber(),
        )
    ) {
      // token时间不足5分钟时重新获取一次token
      refreshToken();
    }
    return true;
  }
  return false;
}
